import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Panel from 'wonderbly-components/lib/Panel';
import { prismicImage } from 'src/common/utils/prismic-image';
import ClipboardText from '../CopyToClipboard/CopyToClipboard';
import './Offer.scss';

const Offer = props => {
  const { title, image, description, offerCtaText, offerCode, copiedNotificationText, isLayoutHorizontal } = props;
  let backgroundImage = prismicImage(image);

  if (isLayoutHorizontal) {
    backgroundImage = prismicImage(image.square);
  }

  return (
    <Panel className={cx('offer-panel', {
      'offer-panel---horizontal': props.isLayoutHorizontal,
    })} border="shadow">
      {image &&
        <div
          className="offer-image"
          style={{ backgroundImage: `url("${backgroundImage}")` }}
        />
      }
      <div className="offer-content">
        {title &&
          <p className="text-kilo">{title}</p>
        }
        {description &&
          <p className="text-base">{description}</p>
        }
        {offerCtaText && offerCode &&
          <ClipboardText
            value={offerCode}
            text={offerCtaText}
            successText={copiedNotificationText}
          />
        }
      </div>
    </Panel>
  );
};

Offer.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.object.isRequired,
  offerCtaText: PropTypes.string,
  copiedNotificationText: PropTypes.string,
  offerCode: PropTypes.string,
  isLayoutHorizontal: PropTypes.bool,
};

export default Offer;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Offer/Offer.js